<template>
  <div class="pan-detail">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="onBack"
      fixed
    />

    <div class="content">
      <van-loading v-if="loading" class="loading" />

      <template v-if="!loading && detail">
        <div class="detail-header">
          <h1 class="detail-title">{{ detail.title }}</h1>
          <div class="detail-tags" v-if="detail.tags && detail.tags.length > 0">
            <van-tag
              v-for="tag in detail.tags"
              :key="tag.id"
              :color="tag.color"
              :text-color="getTagTextColor(tag.color)"
              size="small"
              class="tag-badge"
            >
              {{ tag.name }}
            </van-tag>
          </div>
          <div class="detail-meta">
            <span class="meta-item" v-if="detail.author">
              <van-icon name="contact" size="14" /> {{ detail.author }}
            </span>
            <span class="meta-item" v-if="detail.createdAt">
              <van-icon name="clock-o" size="14" /> {{ detail.createdAt }}
            </span>
            <span class="meta-item" v-if="detail.commentCount">
              <van-icon name="comment-o" size="14" /> {{ detail.commentCount }}
            </span>
            <span class="meta-item" v-if="detail.viewCount">
              <van-icon name="eye-o" size="14" /> {{ detail.viewCount }}
            </span>
          </div>
        </div>

        <div class="detail-body">
          <div class="content-html" v-html="detail.contentHtml"></div>
        </div>
      </template>

      <div v-if="!loading && !detail" class="empty">
        <van-icon name="warning-o" size="48" color="#ddd" />
        <div>暂无详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewPanDetail } from '../utils/api';

export default {
  name: 'PanDetail',
  data() {
    return {
      detail: null,
      loading: false,
      title: '详情'
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    getTagTextColor(bgColor) {
      if (!bgColor) return '#333';
      const hex = bgColor.replace('#', '');
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.5 ? '#333' : '#fff';
    },
    async fetchDetail() {
      const id = this.$route.params.id;
      if (!id) {
        this.$toast('参数错误');
        return;
      }
      this.loading = true;
      try {
        const res = await getNewPanDetail(id);
        if (res) {
          this.detail = this.parseDetail(res);
          if (this.detail) {
            this.title = this.detail.title.length > 12
              ? this.detail.title.slice(0, 12) + '...'
              : this.detail.title;
          }
        }
      } catch (error) {
        console.error('Fetch detail error:', error);
        this.$toast('获取详情失败');
      } finally {
        this.loading = false;
      }
    },
    parseDetail(response) {
      const included = response.included || [];

      const tagsMap = {};
      const usersMap = {};
      included.forEach(item => {
        if (item.type === 'tags') {
          tagsMap[item.id] = {
            id: item.id,
            name: item.attributes && (item.attributes.name || item.attributes.displayName) || '',
            color: item.attributes && item.attributes.color || ''
          };
        }
        if (item.type === 'users') {
          usersMap[item.id] = item.attributes && (item.attributes.displayName || item.attributes.username) || '';
        }
      });

      const postsData = included.filter(item => item.type === 'posts');
      if (postsData.length === 0) return null;

      const firstPost = postsData[0];
      const attrs = firstPost.attributes || {};
      const rels = firstPost.relationships || {};

      const discussionData = response.data || {};
      const discussionAttrs = discussionData.attributes || {};
      const discussionRels = discussionData.relationships || {};

      const tags = (discussionRels.tags && discussionRels.tags.data || [])
        .map(t => tagsMap[t.id]).filter(Boolean);
      const author = (rels.user && rels.user.data && usersMap[rels.user.data.id]) ||
                     (discussionRels.user && discussionRels.user.data && usersMap[discussionRels.user.data.id]) || '';

      let createdAt = '';
      if (attrs.createdAt) {
        const d = new Date(attrs.createdAt);
        createdAt = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      }

      return {
        title: discussionAttrs.title || '',
        contentHtml: attrs.contentHtml || '',
        tags,
        author,
        createdAt,
        commentCount: discussionAttrs.commentCount || 0,
        viewCount: discussionAttrs.viewCount || 0
      };
    },
    onBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.pan-detail {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 46px;
}

.content {
  padding: 12px;
}

.loading {
  text-align: center;
  padding: 40px;
}

.detail-header {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.detail-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin: 0 0 12px;
}

.detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}

.tag-badge {
  border-radius: 8px;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: #999;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.detail-body {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.content-html {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  word-break: break-word;
}

.content-html :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 12px 0;
}

.content-html :deep(a) {
  color: #1989fa;
  text-decoration: none;
}

.content-html :deep(p) {
  margin: 8px 0;
}

.content-html :deep(h1),
.content-html :deep(h2),
.content-html :deep(h3),
.content-html :deep(h4) {
  margin: 16px 0 8px;
  font-weight: 600;
}

.content-html :deep(ul),
.content-html :deep(ol) {
  padding-left: 20px;
  margin: 8px 0;
}

.content-html :deep(blockquote) {
  margin: 12px 0;
  padding: 8px 16px;
  background: #f7f8fa;
  border-left: 4px solid #1989fa;
  border-radius: 4px;
}

.content-html :deep(code) {
  background: #f7f8fa;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 14px;
}

.content-html :deep(pre) {
  background: #f7f8fa;
  padding: 12px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 12px 0;
}

.empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;
  font-size: 14px;
}
</style>
